var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{attrs:{"size":_vm.size,"placeholder":_vm.config && _vm.config.placeholder ? _vm.config.placeholder : ''},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }